import { render, staticRenderFns } from "./SignUpEmail.vue?vue&type=template&id=5055a7e8&"
import script from "./SignUpEmail.vue?vue&type=script&lang=js&"
export * from "./SignUpEmail.vue?vue&type=script&lang=js&"
import style0 from "./SignUpEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports